module.exports = __webpack_public_path__ + "static/media/react od podstaw.e8af1138.pdf";